// extracted by mini-css-extract-plugin
module.exports = {"Terms":"Terms_Terms__4UyTz","Block":"Terms_Block__cIHN5"};